import React, { FunctionComponent } from 'react';
import { ButtonBase, Stack, SxProps, Typography } from '@mui/material';
import moment from 'moment';

import {
  StyledTableCell,
  StyledTableRow,
} from '../../../../../../../components/V2/Table/type1/TableStyles';
import { IManualAdjustment } from '../../../../../../../store/V2/ManualAdjustmentsSlice';
import { IUser } from '../../../../../../../store/UserSlice';
import { getShortName } from '../../../../../../../helper';

interface ManualAdjustmentTableRowProps {
  manualAdjustment: IManualAdjustment;
  onView: () => void;
}

const actionButtonStyles: SxProps = {
  borderRadius: '8px',
  padding: '10px 12px 10px 12px',
  fontWeight: 600,
  fontSize: '14px',
  maxHeight: '36px',
  backgroundColor: '#006C9C',
  color: '#F8FAFC',
  width: 'fit-content',
};

const ManualAdjustmentTableRow: FunctionComponent<ManualAdjustmentTableRowProps> = ({
  manualAdjustment,
  onView,
}) => {
  const dateOfRecordMoment = moment(manualAdjustment.date);
  const dateOfRecordDate = dateOfRecordMoment.format('ddd MMM DD YYYY');
  const dateOfRecordTime = dateOfRecordMoment.format('hh:mm A');
  const createdAtMoment = moment(manualAdjustment.createdAt);
  const createdAtDate = createdAtMoment.format('ddd MMM DD YYYY');
  const createdAtTime = createdAtMoment.format('hh:mm A');
  const tutorData = manualAdjustment.tutor as IUser;
  const createdByData = manualAdjustment.createdBy as IUser;

  let tutorName = '';
  let createdByName = '';

  if (tutorData) {
    tutorName = getShortName(tutorData.firstname, tutorData.lastname, true);
  }

  if (createdByData) {
    createdByName = getShortName(
      createdByData.firstname,
      createdByData.lastname,
      true
    );
  }

  return (
    <StyledTableRow hover key={manualAdjustment._id}>
      <StyledTableCell>
        <Stack>
          <Typography fontSize="14px" fontWeight={500} color="#1E293B">
            {dateOfRecordDate}
          </Typography>
          <Typography fontSize="12px" color="#94A3B8">
            {dateOfRecordTime}
          </Typography>
        </Stack>
      </StyledTableCell>
      <StyledTableCell>
        <Stack>
          <Typography fontSize="14px" fontWeight={500} color="#1E293B">
            {createdAtDate}
          </Typography>
          <Typography fontSize="12px" color="#94A3B8">
            {createdAtTime}
          </Typography>
        </Stack>
      </StyledTableCell>
      <StyledTableCell>
        <Typography
          fontSize="14px"
          fontWeight={500}
          color="#1E293B"
          textTransform="capitalize"
        >
          {tutorName || '-'}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography
          fontSize="14px"
          fontWeight={500}
          color="#1E293B"
          textTransform="capitalize"
        >
          {manualAdjustment.currency} {manualAdjustment.amount.toFixed(2)}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography
          fontSize="14px"
          fontWeight={500}
          color="#1E293B"
          textTransform="capitalize"
        >
          {manualAdjustment.title || '-'}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography
          fontSize="14px"
          fontWeight={500}
          color="#1E293B"
          textTransform="capitalize"
        >
          {manualAdjustment.description || '-'}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography
          fontSize="14px"
          fontWeight={500}
          color="#1E293B"
          textTransform="capitalize"
        >
          {createdByName || '-'}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Stack alignItems="flex-end">
          <ButtonBase sx={{ ...actionButtonStyles }} onClick={onView}>
            View
          </ButtonBase>
        </Stack>
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default ManualAdjustmentTableRow;
